import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Country } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/Country" component={Country} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Country/routes.js